'use client';
import { useEffect } from 'react';

export default function NotFound() {
  useEffect(() => {
    document.title = '404 ページが見つかりません';
  }, []);
  return (
    <html>
      <body>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <h1
              style={{
                display: 'inlineBlock',
                margin: '0px 20px 0px 0px',
                padding: '0px 23px 0px 0px',
                borderRight: '1px solid rgba(0, 0, 0, 0.3)',
                fontSize: '24px',
                fontWeight: 500,
                verticalAlign: 'top',
                lineHeight: '49px'
              }}
            >
              404
            </h1>
            <div
              style={{
                display: 'inline-block'
              }}
            >
              <h2
                style={{
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '49px',
                  margin: 0
                }}
              >
                ページが見つかりません
              </h2>
            </div>
          </div>
          <a
            href="/"
            style={{
              marginTop: '30px',
              fontSize: '12px',
              textDecoration: 'underline',
              color: '#000',
              fontWeight: 400
            }}
          >
            トップページに戻る
          </a>
        </div>
      </body>
    </html>
  );
}
